// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  private: false,
  apiKey: 'ANYi7lXjvxIqmxkFLZXC1oe8qAKzVXAu1t5piroKd05d7878',
  apiUrls: {
    contactEnquiry: 'https://listings.caymanmarshalladmin.com/api/v1/email-enquiry',
    listings: 'https://listings.caymanmarshalladmin.com/api/v2/listings'
  },
  hostname: 'oakville'
};

